import React, { useState, cloneElement, useMemo, useCallback } from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { Button, Modal, CheckboxField } from '@adc/ui-adc'
// @ts-ignore no types
import { useApplicationModals } from '@adc/ui-adc'
import SparkOfferInterstitial from './sparkOfferInterstitial'
// @ts-ignore no types
import styles from './index.scss'

const cx = classnames.bind(styles)

interface RedirectToSparkOfferSiteProps {
  sparkOfferUrl: string
  children: any
}

const RedirectToSparkOfferSite = ({
  sparkOfferUrl,
  children,
}: RedirectToSparkOfferSiteProps) => {
  const [modalOpen, setModalOpen] = useState(false)
  const hideModal = () => setModalOpen(false)
  const { open } = useApplicationModals()
  const redirectToSparkOffer = () => {
    window.open(sparkOfferUrl, '_blank')
    if (modalOpen) {
      hideModal()
    }
  }
  const title = (
    <h3 className={cx('spark-offer-modal-title')}>
      You are leaving Auction.com
    </h3>
  )
  const body = (
    <div>
      <SparkOfferInterstitial />
      <br />
    </div>
  )
  const openModal = useCallback(() => {
    open('confirmation', sparkOfferModalProps)
  }, [open])

  const sparkOfferModalProps: any = useMemo(
    () => ({
      children: body,
      elmId: 'spark_offer_modal',
      size: 'tiny',
      title,
      confirmButton: {
        onClick: redirectToSparkOffer,
        label: 'Continue',
      },
      hideCancelButton: true,
    }),
    []
  )

  const button = cloneElement(children, { onClick: () => openModal() })
  return <span>{button}</span>
}
export default RedirectToSparkOfferSite
